export const stateRegisterValues = [
  {
    'key': 'A',
    'value': 'A',
    'text': 'ACTIVO',
  },
  {
    'key': 'I',
    'value': 'I',
    'text': 'INACTIVO',
  },
];
